<template>
  <a class="backlink" href="" @click.prevent="goBack">< retour</a>
</template>

<script>
export default {
  name: "BackLink",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .backlink{ color: $color1; font-size: 12px; font-family: 'ClanPro'; margin-top: 20px; margin-bottom: 50px; display: block; width: 100%;
    &.white{ color: white; }
  }
</style>



// WEBPACK FOOTER //
// src/components/Global/BackLink.vue